import axios from "axios";
import { clearAuthStorage, markLogoutSignal } from "./session";

let interceptorInstalled = false;
let redirectInProgress = false;

function logoutToLogin() {
    if (redirectInProgress) {
        return;
    }

    redirectInProgress = true;
    clearAuthStorage();
    markLogoutSignal();

    if (window.location.pathname !== "/") {
        window.location.replace("/");
    }

    window.setTimeout(() => {
        redirectInProgress = false;
    }, 0);
}

export function installAuthGuard() {
    if (interceptorInstalled) {
        return;
    }

    interceptorInstalled = true;

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const token = localStorage.getItem("token");

            if (token && (status === 401 || status === 403)) {
                logoutToLogin();
            }

            return Promise.reject(error);
        }
    );
}
